module.exports = __webpack_public_path__ + "img/rfidCwg.f0bf6c3b.png";